import { CloseIcon } from '@room-match/shared-ui-components';
import {
  AddCreditModalButton,
  AddCreditTextField,
  ButtonCont,
  CancelCreditModalButton,
  InputBinder,
  Label,
  ModalCont,
  ModalTitle,
} from './Resume.styles';
import { FormikProps, useFormik } from 'formik';
import { IResumeCredit } from 'shared/interfaces/IProfile';
import * as yup from 'yup';

interface Props {
  item: any;
  onClose: VoidFunction;
}
function AddCreditModal({ item, onClose }: Props) {
  const initialValues: IResumeCredit = {
    year: '',
    title: '',
    director: '',
    role: '',
    media: [],
  };

  const handleSubmit = (values: IResumeCredit) => {
    //TODO: submit
    console.log('to submit', values);
  };

  const createProfileValidationSchema: yup.SchemaOf<IResumeCredit> = yup.object().shape({
    year: yup.string().required(),
    title: yup.string().required(),
    director: yup.string().required(),
    role: yup.string().required(),
    media: yup.array(),
  });

  const form: FormikProps<IResumeCredit> = useFormik({
    initialValues,
    validationSchema: createProfileValidationSchema,
    onSubmit: (values, helpers) => {
      handleSubmit(values);
      helpers.resetForm();
      return;
    },
  });

  return (
    <ModalCont>
      <CloseIcon style={{ width: 16, alignSelf: 'flex-end', cursor: 'pointer' }} onClick={onClose} />
      <ModalTitle>Add Credit for {item.name}</ModalTitle>
      <InputBinder>
        <Label>Year</Label>
        <AddCreditTextField
          variant="outlined"
          value={form.values.year}
          name="year"
          onChange={form.handleChange}
          placeholder="Type here..."
        />
      </InputBinder>
      <InputBinder>
        <Label>Title</Label>
        <AddCreditTextField
          variant="outlined"
          value={form.values.title}
          name="title"
          onChange={form.handleChange}
          placeholder="Type here..."
        />
      </InputBinder>
      <InputBinder>
        <Label>Director</Label>
        <AddCreditTextField
          variant="outlined"
          value={form.values.director}
          name="director"
          onChange={form.handleChange}
          placeholder="Type here..."
        />
      </InputBinder>
      <InputBinder>
        <Label>Role</Label>
        <AddCreditTextField
          variant="outlined"
          value={form.values.role}
          name="role"
          onChange={form.handleChange}
          placeholder="Type here..."
        />
      </InputBinder>
      <ButtonCont>
        <CancelCreditModalButton>Add Media</CancelCreditModalButton>
        <AddCreditModalButton onClick={form.submitForm}>Add Credit</AddCreditModalButton>
      </ButtonCont>
    </ModalCont>
  );
}

export default AddCreditModal;
